import { itemPages } from '../../../config/constantLists'
const DashboardLayout = () => import('../../../layouts/DashboardLayout.vue')
const AboutUs = () => import('./views/AboutUs')
const AboutUsView = () => import('./views/AboutUsView')

export default [
  {
    path: '/about-us',
    component: DashboardLayout,
    meta: { auth: true },
    children: [
      {
        path: '',
        name: 'generalSettings.aboutUs',
        meta: { auth: true },
        component: AboutUs
      },
      {
        path: 'view/:id?',
        name: 'generalSettings.aboutUsView',
        meta: { auth: true, currentPage: itemPages.view },
        component: AboutUsView,
        props: true
      },
      // {
      //   path: 'create',
      //   name: 'generalSettings.aboutUsCreate',
      //   meta: { auth: true, currentPage: itemPages.create },
      //   component: AboutUsView
      // },
      {
        path: 'update/:id?',
        name: 'generalSettings.aboutUsUpdate',
        meta: { auth: true, currentPage: itemPages.update },
        component: AboutUsView,
        props: true
      }
    ]
  }
]
